import { render, staticRenderFns } from "./TableViewWrapper.vue?vue&type=template&id=f6767d44&"
import script from "./TableViewWrapper.vue?vue&type=script&lang=js&"
export * from "./TableViewWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports